import { ACTION_NAMES, ACTION_TYPES } from "../../../constants/actionBar";
import {
  SFPublishedWithChangesIcon,
  SFEditIcon,
  SFAddIcon,
  SFArrowForwardIcon,
  SFArrowBackIcon,
  SFUploadIcon,
} from "../../icons";

/**
 * Retrieves the array of button action definition templates.
 * @param {Function} t The translation function from i18next.
 * @returns {Array} An array of button action definition templates.
 */
export const getButtonActionDefTemplates = (t) => {
  return [
    {
      name: ACTION_NAMES.UPDATE,
      type: ACTION_TYPES.BUTTON,
      buttonProps: {
        icon: <SFPublishedWithChangesIcon />,
        iconPlacement: "start",
        variant: "primary",
        tooltip: t("components.actionBar.tooltips.update"),
        overflowLabel: t("components.actionBar.tooltips.update"),
        label: t("components.actionBar.tooltips.update"),
      },
      confirmation: true,
      confirmationProps: {
        header: t("components.dialog.confirmation"),
        primaryLabel: t("components.dialog.confirm"),
        secondaryLabel: t("components.dialog.cancel"),
      },
    },
    {
      name: ACTION_NAMES.PUBLISH,
      type: ACTION_TYPES.BUTTON,
      buttonProps: {
        icon: <SFPublishedWithChangesIcon />,
        iconPlacement: "start",
        variant: "primary",
        tooltip: t("components.actionBar.tooltips.publish"),
        overflowLabel: t("components.actionBar.tooltips.publish"),
        label: t("components.actionBar.tooltips.publish"),
      },
      confirmation: true,
      confirmationProps: {
        header: t("components.dialog.confirmation"),
        primaryLabel: t("components.dialog.confirm"),
        secondaryLabel: t("components.dialog.cancel"),
      },
    },
    {
      name: ACTION_NAMES.EDIT,
      type: ACTION_TYPES.BUTTON,
      buttonProps: {
        icon: <SFEditIcon />,
        iconPlacement: "start",
        variant: "primary",
        tooltip: t("components.actionBar.tooltips.edit"),
        overflowLabel: t("components.actionBar.tooltips.edit"),
        label: t("components.actionBar.tooltips.edit"),
      },
    },
    {
      name: ACTION_NAMES.CANCEL,
      type: ACTION_TYPES.BUTTON,
      buttonProps: {
        variant: "secondary",
        tooltip: t("components.actionBar.tooltips.cancel"),
        overflowLabel: t("components.actionBar.tooltips.cancel"),
        label: t("components.actionBar.tooltips.cancel"),
      },
    },
    {
      name: ACTION_NAMES.SAVE,
      type: ACTION_TYPES.BUTTON,
      buttonProps: {
        variant: "primary",
        tooltip: t("components.actionBar.tooltips.save"),
        overflowLabel: t("components.actionBar.tooltips.save"),
        label: t("components.actionBar.tooltips.save"),
      },
    },
    {
      name: ACTION_NAMES.ADD,
      type: ACTION_TYPES.BUTTON,
      buttonProps: {
        icon: <SFAddIcon />,
        iconPlacement: "start",
        variant: "utility",
        tooltip: t("components.actionBar.tooltips.add"),
        overflowLabel: t("components.actionBar.tooltips.add"),
        label: t("components.actionBar.tooltips.add"),
      },
    },
    {
      name: ACTION_NAMES.CLOSE,
      type: ACTION_TYPES.BUTTON,
      buttonProps: {
        variant: "secondary",
        tooltip: t("components.actionBar.tooltips.close"),
        overflowLabel: t("components.actionBar.tooltips.close"),
        label: t("components.actionBar.tooltips.close"),
      },
    },
    {
      name: ACTION_NAMES.NEXT,
      type: ACTION_TYPES.BUTTON,
      buttonProps: {
        icon: <SFArrowForwardIcon />,
        iconPlacement: "end",
        variant: "primary",
        tooltip: t("components.actionBar.tooltips.next"),
        overflowLabel: t("components.actionBar.tooltips.next"),
        label: t("components.actionBar.tooltips.next"),
      },
    },
    {
      name: ACTION_NAMES.BACK,
      type: ACTION_TYPES.BUTTON,
      buttonProps: {
        icon: <SFArrowBackIcon />,
        iconPlacement: "start",
        variant: "secondary",
        tooltip: t("components.actionBar.tooltips.back"),
        overflowLabel: t("components.actionBar.tooltips.back"),
        label: t("components.actionBar.tooltips.back"),
      },
    },
    {
      name: ACTION_NAMES.UPLOAD,
      type: ACTION_TYPES.BUTTON,
      buttonProps: {
        icon: <SFUploadIcon />,
        iconPlacement: "start",
        variant: "primary",
        tooltip: t("components.actionBar.tooltips.upload"),
        overflowLabel: t("components.actionBar.tooltips.upload"),
        label: t("components.actionBar.tooltips.upload"),
      },
    },
    {
      name: ACTION_NAMES.PREVIEW,
      type: ACTION_TYPES.BUTTON,
      buttonProps: {
        variant: "utility",
        tooltip: t("components.actionBar.tooltips.preview"),
        overflowLabel: t("components.actionBar.tooltips.preview"),
        label: t("components.actionBar.tooltips.preview"),
      },
    },
  ];
};
